// extracted by mini-css-extract-plugin
export default {"container":"TotalSection_container__1qCro","onlyForDesktop":"TotalSection_onlyForDesktop__8TaS9","totalLabel":"TotalSection_totalLabel__j4UQe"};